// extracted by mini-css-extract-plugin
export default {"table":"thresholds_table-module___table___f3542e4b"};